import React from 'react';
import { CircularProgress, Grid, InputAdornment, MenuItem, TextField } from '@mui/material';
import type { SignupFormValues } from '../../hooks/useSignupForm';

interface CompanyInfoFieldsProps {
  values: SignupFormValues;
  fieldErrors: Partial<Record<keyof SignupFormValues, string>>;
  handleChange: (field: keyof SignupFormValues) => (value: any) => void;
  isCheckingCNPJ: boolean;
  onCNPJChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Campos de "Dados da Empresa" (nome, CNPJ, telefone, dia de pagamento) do cadastro — sem o
 * seletor de logo, que fica em CompanyLogoField.tsx. Extraído de SignupForm.tsx (F7).
 */
export const CompanyInfoFields: React.FC<CompanyInfoFieldsProps> = ({
  values,
  fieldErrors,
  handleChange,
  isCheckingCNPJ,
  onCNPJChange,
  onPhoneChange,
}) => {
  return (
    <>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Nome da Empresa"
          value={values.companyName}
          onChange={(e) => handleChange('companyName')(e.target.value)}
          error={!!fieldErrors.companyName}
          helperText={fieldErrors.companyName || 'Digite o nome da empresa'}
          inputProps={{ maxLength: 200 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="CNPJ"
          value={values.cnpj}
          onChange={onCNPJChange}
          placeholder="00.000.000/0000-00"
          inputProps={{ maxLength: 18 }}
          error={!!fieldErrors.cnpj}
          helperText={
            isCheckingCNPJ
              ? 'Verificando disponibilidade...'
              : fieldErrors.cnpj ||
                'Formato: XX.XXX.XXX/XXXX-XX (suporta formato alfanumérico)'
          }
          InputProps={{
            endAdornment: isCheckingCNPJ ? (
              <InputAdornment position="end">
                <CircularProgress size={20} />
              </InputAdornment>
            ) : null,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Telefone"
          value={values.phone}
          onChange={onPhoneChange}
          placeholder="(00) 00000-0000"
          inputProps={{ maxLength: 15 }}
          error={!!fieldErrors.phone}
          helperText={fieldErrors.phone || 'Opcional - Digite telefone com DDD'}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Dia de Pagamento *"
          value={values.paymentDay}
          onChange={(e) => handleChange('paymentDay')(e.target.value)}
          select
          SelectProps={{ displayEmpty: true }}
          error={!!fieldErrors.paymentDay}
          helperText={fieldErrors.paymentDay || 'Escolha o dia de vencimento (5, 10, 15, 20 ou 25)'}
          required
        >
          <MenuItem value="">
            <em>Selecione...</em>
          </MenuItem>
          {[5, 10, 15, 20, 25].map((d) => (
            <MenuItem key={d} value={String(d)}>
              {d}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </>
  );
};

export default CompanyInfoFields;
